import { useState } from "react";
import { Row, Button } from "reactstrap";
import { useDispatch } from "react-redux";
import { parseJobPortalResume } from "../../../store/job/action";
import cloudUpload from "../../../assets/svg/upload-cloud.svg";
import "./ResumeUpload.scss";

export default function ResumeUpload({ field, form, errorMsg, file, setFile }) {
  const dispatch = useDispatch();
  const [enableUpload, setEnableUpload] = useState(true);

  // Handle resume upload
  function handleResumeUpload(file) {
    setFile(file);
    setEnableUpload(false);
    form.setFieldValue(field.name, file);
  }

  // Handle resume parse
  function handleResumeParse() {
    const formData = new FormData();
    formData.append("resumes[0].file", file);
    formData.append("resumes[0].fileName", file.name);
    dispatch(parseJobPortalResume(formData))
  }

  // Handle resume clear
  function handleResumeClear() {
    const inputField = document.querySelector("input[type=file]");
    inputField.value = null;
    setFile(null);
    setEnableUpload(true);
    form.setFieldValue(field.name, null);
  }

  return (
    <div className="my-3 resumeupload-container">
      <h6>Upload CV</h6>
      <p className="mt-3 mb-0 text-muted">
        Document Title<span className="text-danger">*</span>
      </p>
      <Row className="mx-0 mt-1 position-relative text-center rounded upload-box">
        {!enableUpload && (
          <div className="position-absolute w-100 h-100 z-3 cv-upload-overlay"></div>
        )}
        <input
          className="px-0 position-absolute w-100 h-100 opacity-0 z-1"
          type="file"
          name="resume"
          accept=".pdf,.doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          onChange={(e) => handleResumeUpload(e.target.files[0])}
        />
        <img src={cloudUpload} alt="upload" className="cloud-img" />
        <span className="position-relative fs-14">
          <span className="fw-normal" style={{ color: "#6941C6" }}>
            Click to upload
          </span>{" "}
          or drag and drop
        </span>
        <p className="mb-3 text-muted fs-12">DOC, DOCX or PDF (max. 2MB)</p>
      </Row>
      {!enableUpload && file !== null && (
        <div className="d-flex align-items-center gap-2 mt-4 p-2 border border-light rounded">
          {file?.type === "application/pdf" ? (
            <i className="bx bxs-file-pdf fs-36" style={{ color: "#D92D20" }} />
          ) : (
            <i className="mdi mdi-file-word fs-36" style={{ color: "#2B579A" }} />
          )}
          <div>
            <p className="mb-0 fs-12">{file?.name}</p>
            <p className="mb-0 fs-12 color-slategray">{Math.round(file?.size/1000)} KB</p>
          </div>
          <i className="mdi mdi-check ms-auto me-1 check-icon" />
        </div>
      )}
      {errorMsg}
      <Row className="mx-0 mt-3">
        <div className="d-flex gap-3 px-0 justify-content-end">
          <Button className="clear-btn" onClick={handleResumeClear}>Clear</Button>
          <Button className="parse-btn" disabled={enableUpload} onClick={handleResumeParse}>Upload & Auto Fill</Button>
        </div>
      </Row>
      {/* <div className="mt-2 p-2 rounded bg-honeydew">Resume parsed successfully. Carefully review your information before submitting the application.</div> */}
    </div>
  );
}
